class TokenManager {
  private refreshPromise: Promise<void> | null = null;

  async refreshIfNeeded(expiresAt: string, refreshFn: () => Promise<void>): Promise<void> {
    if (!this.isTokenExpiringSoon(expiresAt)) {
      return;
    }

    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    this.refreshPromise = refreshFn().finally(() => {
      this.refreshPromise = null;
    });

    return this.refreshPromise;
  }

  private isTokenExpiringSoon(expiresAt: string): boolean {
    const expiryTime = new Date(expiresAt).getTime();
    const currentTime = Date.now();
    const fiveMinutes = 5 * 60 * 1000;
    return expiryTime - currentTime < fiveMinutes;
  }

  reset(): void {
    this.refreshPromise = null;
  }

  isRefreshing(): boolean {
    return this.refreshPromise !== null;
  }
}

export const tokenManager = new TokenManager();